// extracted by mini-css-extract-plugin
module.exports = {"segment":"_3-OvdaSeUNox","segment_active":"_2tMXedJvrCs-","segment_disabled":"_2sNwdjorBa3s","ellipse":"RE_7vLSXeYGf","checked":"PX-RCGN-K-cz"};